<template>
  <v-app>
    <Snackbar></Snackbar>
    <Dialog></Dialog>
    <iframe id="sr_iframe_localstorage"
      v-if="doMainIframeExist"
      :src="$axios.defaults.baseURL"
      class="hidden-iframe"
      style="display:none;"
    ></iframe>
    <router-view></router-view>
  </v-app>
</template>

<script>
import { Types } from "./store/modules/auth"
import Snackbar from "./components/common/template/Snackbar"
import Dialog from "./components/common/template/Dialog"

export default {
  name: "App",
  components: {
    Dialog,
    Snackbar,
  },
  mounted() {
    // TODO: REMOVE THI CONSOLE LOG
    // console.log("TRY TO GET USER WITH POSTMESSAGE")
    this.getItem("user").then(() => {
      // TODO: REMOVE THI CONSOLE LOG
      // console.log("GET ITEM => ", response)
    })
  },
  created() {
    this.$axios.interceptors.response.use(undefined, err => {
      return new Promise(() => {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch(Types.actions.AUTH_LOGOUT)
          this.$router.push("/login")
        }
        throw err
      })
    })
  },
  methods: {
    doMainIframeExist() {
      return document.getElementById("sr_iframe_localstorage") !== null
    },
    actionItem(payload) {
      return new Promise((resolve, reject) => {
        function messageHandler(event) {
          // We test if the origin is the same as the API URL and if it's the right handled request
          if (
            // event.origin === this.$glob constants.URL_API &&
            event.data.action === payload.returnValue &&
            event.data.key === payload.key
          ) {
            // If the data property is not null and not equal to false we resole the promise
            if (event.data && event.data.hasOwnProperty("data") && event.data.data !== null) {
              resolve(event.data)
            } else {
              reject(event.data)
            }
          }
        }

        // TODO: REMOVE THI CONSOLE LOG
        // console.log(messageHandler)

        // The listener id added at any actionItem call
        window.removeEventListener("message", messageHandler)
        window.addEventListener("message", messageHandler, false)

        // TODO: REMOVE THI CONSOLE LOG
        // console.log("EVENT LISTENER CREATED")

        // Now we get the iframe to exec the postMessage function on it with the payload passed by parameters
        const iframe = document.getElementById("sr_iframe_localstorage")

        // TODO: REMOVE THI CONSOLE LOG
        // console.log("IFRAME", iframe)

        if (iframe) {
          const iframeContent = iframe.contentWindow
          iframeContent.postMessage(payload, "*")

          // TODO: REMOVE THI CONSOLE LOG
          // console.log("IFRAME CONTENT => ", iframeContent)
        }
      })
    },
    /*
    getItem return an item accross the iframe
     */
    getItem(key) {
      // TODO: REMOVE THI CONSOLE LOG
      // console.log("PAYLOAD => ", {
      //   action: "get",
      //   key,
      //   returnValue: "returnGet",
      // })
      return this.actionItem({
        action: "get",
        key,
        returnValue: "returnGet",
      })
    },
    /*
    getItem return all items form the localstorage accross the iframe
     */
    allItems() {
      return this.actionItem({ action: "all", returnValue: "returnAll" })
    },
    /*
    setItem an item in the localStorage accross the iframe
     */
    setItem(key, value) {
      return this.actionItem({
        action: "set",
        key,
        value,
        returnValue: "returnSet",
      })
    },
    /*
    unsetItem remove an item in the localStorage across the iframe
     */
    unsetItem(key) {
      return this.actionItem({
        action: "unset",
        key,
        returnValue: "returnUnset",
      })
    },
  },
}
</script>

<style lang="scss">
@import "./sass/main.scss";
</style>
